import DOMPurify from "dompurify";

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    "p", "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li", "strong", "em", "b", "i", "u",
    "a", "blockquote", "img", "br", "hr", "span", "div",
    "table", "thead", "tbody", "tr", "th", "td",
    "figure", "figcaption", "pre", "code", "sup", "sub",
    "video", "source",
  ],
  ALLOWED_ATTR: [
    "href", "src", "alt", "class", "target", "rel",
    "width", "height", "style", "id", "title",
    "colspan", "rowspan", "data-float",
    "data-image-frame", "data-frame-h", "data-pos-x", "data-pos-y",
    "data-zoom", "data-margin",
    "data-video-embed", "data-provider", "data-src",
    "controls", "preload", "playsinline", "poster", "muted", "loop",
    "type",
  ],
  RETURN_TRUSTED_TYPE: false as const,
};

/** Sanitize HTML content to prevent XSS attacks */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, SANITIZE_CONFIG) as string;
}
